import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import staff2 from '../../../../images/staff/member_1.png';
import DatePicker, { DateObject } from "react-multi-date-picker";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const UserEdit = ({ show, onClose, data, refresh }) => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [deptOpt, setDeptOpt] = useState([]);
    const [selDept, setSelDept] = useState(null);
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/get_department`);
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.department_name,
                }));
                setDeptOpt(formatted);
            } catch (error) {
                console.log('Error fetching lead types:', error);
            }
        };

        fetchLeadTypes();
    }, []);

    const [jobRole, setJobRole] = useState([]);
    const [selectedJobRole, setSelectedJobRole] = useState(null);
    useEffect(() => {
        // if (selDept) {
            axios.get(`${baseURL}/dropdown/get_job_role`)
                .then(res => {
                    // console.log("Job Role API Response:", res.data);
                    const data = res.data?.data || [];

                    const formatted = data.map(role => ({
                        value: role.sno,
                        label: role.jobrole_name
                    }));
                    setJobRole(formatted);
                })
                .catch(err => {
                    console.log("Error loading job roles", err);
                    setJobRole([]);
                });
        // }
    }, []);

    const [role, setRole] = useState([]);
    const [selRolePer, setSelRolePer] = useState(null);
    useEffect(() => {
        const params = { branch_id: branch_id };
        axios.get(`${baseURL}/manageuser/active`, { params: params })
            .then(res => {
                // console.log("Role API Response:", res.data);
                const data = res.data?.data || [];
                const formatted = data.map(role => ({
                    value: role.sno, // adjust if your API uses a different field
                    label: role.user_role_name // adjust field name based on API response
                }));
                setRole(formatted);
            })
            .catch(err => {
                console.log("Error loading roles", err);
                setRole([]);
            });
    }, []);

    const [dateOfJoining, setDateOfJoining] = useState(null);
    const [transfer_reason, setReason] = useState('');

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        // if (!dateOfJoining) {
        //     newErrors.date = "This Field is Required.";
        // }

        if (!selDept) {
            newErrors.dept = "This Field is Required.";
        }

        if (!selectedJobRole) {
            newErrors.role = "This Field is Required.";
        }

        // if(!transfer_reason){
        //     newErrors.reason = "This Field is Required.";
        // }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }


        const postData = {
            role: selRolePer,
            department_id: selDept,
            job_role_id: selectedJobRole,
            transfer_reason: transfer_reason,
            user_id: user_id
        };

        // console.log(postData);

        axios.put(`${baseURL}/managestaff/transfer/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Staff Transfer Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Staff Transfer Failed");
            });
    };

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // display names
    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return (
        <Modal className="modal fade" show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <div className='d-flex align-items-center gap-3 flex-wrap'>
                        <h3 className="modal-title text-white">Staff Role Transfer</h3>
                    </div>
                    <Button variant="" type="button" className="close px-6 py-2 text-white" onClick={onClose}>
                        <span>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    {/* info */}
                    <div className='row mb-2'>
                        <div className='col-lg-4 mb-1 d-flex justify-content-center'>
                            <LightGallery
                                onInit={onInit}
                                speed={500}
                                plugins={[lgThumbnail, lgZoom]}
                            >
                                <div data-src={data.staff_image_url ? data.staff_image_url : staff2}>
                                    <img src={data.staff_image_url ? data.staff_image_url : staff2} alt={data.employee_name} className='cursor-pointer w-125px h-125px' />
                                </div>
                            </LightGallery>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Staff Name</label>
                                <label className='text-danger font-w500 fs-6'>{capitalizeFirstLetter(data.employee_name)}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Date of Joining</label>
                                <label className='text-danger font-w500 fs-6'>{formatDate(data.date_of_joining)}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 mb-2'>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Department</label>
                                <label className='text-danger font-w500 fs-6'>{data.department?.department_name ?? 'N/A'}</label>
                            </div>
                            <div className='row d-flex align-items-start justify-content-start flex-column gap-1 mb-2'>
                                <label className='text-black font-w500 fs-6'>Job Role</label>
                                <label className='text-danger font-w500 fs-6'>{data.job_role?.jobrole_name ?? 'N/A'}</label>
                            </div>
                        </div>
                    </div>

                    {/* form */}
                    <div className='col-lg-12'>
                        <div className='row'>

                            <div className="col-lg-4 mb-2">
                                <label className="text-black font-w500 fs-7">Department <span className="required">*</span></label>
                                <Select placeholder="Select Department"
                                    options={deptOpt}
                                    onChange={(e) => setSelDept(e.value)}
                                />
                                {errors.dept && (
                                    <div className="text-danger">{errors.dept}</div>
                                )}
                            </div>
                            <div className="col-lg-4 mb-4">
                                <label className="text-black font-w500 fs-7">Job Role <span className="required">*</span></label>
                                <Select placeholder='Select Job Role'
                                    onChange={(e) => setSelectedJobRole(e.value)}
                                    options={jobRole}
                                />
                                {errors.role && <span className="text-danger">{errors.role}</span>}
                            </div>
                            <div className="col-lg-4 mb-4">
                                <label className="text-black font-w500 fs-7">Role </label>
                                <Select placeholder='Select Role'
                                    onChange={(e) => setSelRolePer(e.value)}
                                    options={role}
                                />
                            </div>

                            <div className="col-lg-12 mb-4">
                                <label className="text-black font-w500 fs-7">Reason</label>
                                <textarea rows={8} className="form-control" name="comment" placeholder="Reason"
                                    maxLength={200}
                                    onChange={(e) => setReason(e.target.value)}
                                    value={transfer_reason}
                                />
                                {/* {errors.reason && <span className="text-danger">{errors.reason}</span>} */}
                            </div>

                        </div>
                    </div>

                    {/* submit */}
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Transfer Staff <i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default UserEdit;
